import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class NavbarService {

    toggleSubject: Subject<boolean> = new Subject;
   
}
